import { useEffect, memo } from 'react';
import { useSelector } from 'react-redux';
import { Backdrop, Typography, Box, Button } from '@mui/material';
import { TfiReload } from "react-icons/tfi";
import { FiWifiOff, FiWifi } from "react-icons/fi";
import { BsCurrencyRupee } from "react-icons/bs";
import styles from "./style.module.scss"
import { LoaderBRE } from './LoaderBRE';
import { MdLogout } from "react-icons/md";


let prevLoaderType = null;
let prevLoading = false;

const Loader = () => {
  const { loading, message, loaderType } = useSelector(
    (s) => s.contextualLoader
  );

  useEffect(() => {
    prevLoaderType = loaderType; 
    prevLoading = loading;
  }, [loaderType, loading]);

  if(loaderType==='bre' || (prevLoaderType === 'bre' && prevLoading === loading)) {
    return <LoaderBRE loading={loading} />
  }
  return <>
    <Box className={styles.ringContainer}>
      <Box className={styles.ring} />
      <Box className={styles.ping} />
      <Box />
      <Box className={styles.centralLogo}>
        <Box className={styles.rupeeText}><BsCurrencyRupee /></Box>
      </Box>
    </Box>
   { message ? <Typography className={styles.contextualMsg} component="h6" mt={2}>
      {message}
    </Typography> : null}
    <Box className={styles.loadingDots}>
      <Box className={styles.dot} />
      <Box className={`${styles.dot} ${styles.dot2}`} />
      <Box className={`${styles.dot} ${styles.dot3}`} />
    </Box>
  </>
}

const ActionBtn = ({statusCode, type}) => {
  if((statusCode === 401 || statusCode === 403)) {
    return <Button className={styles.actionBtn } onClick={ () => window.location.href = "/logout" }>
        <MdLogout size={22} color="#ffffff" /> Logout
      </Button>
  }
  return <Button className={styles.actionBtn } onClick={ () => window.location?.reload(true)}>
          {type !== "network" ? <TfiReload color="rgb(255, 255, 255)" /> : <FiWifi color="rgb(255, 255, 255)" />}
        Retry
      </Button>
}

const State = ({ type, message, statusCode }) => {
  const errorText = <>
    <Box component="h3">{message || "Something went wrong"}</Box>
    <Box component="p">We're having trouble loading this page</Box>
  </>
  const nextWorkText = <>
    <Box component="h3">No Internet Connection</Box>
    <Box component="p">Please check your connection and try again</Box>
  </>
  return <>
    <Box className={styles.errorState}>
      <Box className={`${styles.icon} ${type !== "network" ? styles.reloadIcon : ''}`}>
          {type !== "network" ? <TfiReload color="rgb(239, 68, 68)" /> : <FiWifiOff color="rgb(156, 163, 175)" />}
      </Box>
      <Box className="">
        {type === "network" ? nextWorkText : errorText}
      </Box>
      <ActionBtn statusCode={statusCode} type={type} />
      
    </Box>
  </>
}

const ContextualLoader = () => {
   const { loading, error, message, statusCode } = useSelector(
    (s) => s.contextualLoader
  );
  const isLoading = loading || error ? true : false;
  return (
    <Backdrop className={styles.backdropBlurSm} open={isLoading} 
      sx={{
        zIndex: 1300,
        color: "#fff",
        "@media (min-width:992px)": {
          position: "relative",
        },
      }}
    >
      <Box textAlign="center">
        {loading && <Loader />}
        {error && <State type={error} message={message} statusCode={statusCode} />}
      </Box>
    </Backdrop>
  );
};

export default memo(ContextualLoader);
